module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-6 col-md-12 col-xs-12 px-6 cat-element"
  }, [_c('div', {
    staticClass: "cl-card"
  }, [_c('div', {
    staticClass: "element-header"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('elements.subtitle')) + " " + _vm._s(_vm.learningElementLangth) + "\n    ")]), _vm._v(" "), _vm._l((_vm.learningElement), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "element"
    }, [_c('div', {
      staticClass: "element-completed"
    }, [_c('div', {
      staticClass: "icon",
      class: {
        'active': _vm.isCorrectAnswerRatio(item.correct_count, item.total_count)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "element-container"
    }, [_c('div', {
      staticClass: "element-title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "element-grade"
    }, [_vm._v(_vm._s(_vm.getTranslatedName(_vm.gradeMap[item.grade_id])) + " |")]), _vm._v(" "), _c('div', {
      staticClass: "element-correct-answers"
    }, [_vm._v(_vm._s(_vm.$t('common.answers_rate')) + " "), _c('span', [_vm._v(_vm._s(_vm.correctAnswer(item.correct_count, item.total_count)) + "%")])])]), _vm._v(" "), (!_vm.isParentUser) ? _c('div', {
      staticClass: "element-action"
    }, [_c('span', {
      on: {
        "click": function($event) {
          return _vm.goToLearningStore(item.id)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('common.learning')) + " >")])]) : _vm._e()])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60e5aa2e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/cat-proficiency/components/CatElement.vue
// module id = 1581
// module chunks = 1